import React from 'react';
import styles from './ColoredBars.module.css';

// Small fixed palette so the dashboard reads as a few meaningful colors:
// blue = neutral/in flow, grey = waiting, green = positive, red = negative.
export const BAR_COLORS = {
  blue: '#076bfd',
  grey: '#8896ab',
  green: '#00c221',
  red: '#e20000',
};

/**
 * Gives each bar of an Apollo BarChart its own color, in data order.
 * BarChart draws every bar in one fill and has no per-bar color prop, so the
 * colors are applied from CSS to the bar paths of the chart rendered inside.
 *
 * @param {string[]} colors - one color per bar (up to 6), in data order
 */
const ColoredBars = ({ colors, className = '', children, ...rest }) => {
  const style = {};
  colors.slice(0, 6).forEach((color, index) => {
    style[`--bar-color-${index + 1}`] = color;
  });
  return (
    <div
      className={`${styles.coloredBars} ${className}`}
      style={style}
      {...rest}
    >
      {children}
    </div>
  );
};

/**
 * Same idea for Apollo's ClusterColumnChart (two series per cluster): colors the
 * columns and the legend swatches, which otherwise use Apollo's default purple/blue.
 *
 * @param {[string, string]} colors - colors of the first and second series
 */
export const ColoredClusters = ({ colors, children }) => (
  <div
    className={styles.coloredClusters}
    style={{ '--series-color-1': colors[0], '--series-color-2': colors[1] }}
  >
    {children}
  </div>
);

export default ColoredBars;
